import axios from 'axios';
import { get } from 'lodash';
import { v4 as uuidv4 } from 'uuid';

import config from './config';
import { useInitialInfoStore } from '@src/emp-3.0/store/useInitialInfo';

const instance = axios.create(config);

const getCustomerID = () => {
  const store = 'store' in window ? window.store.getState() : {};
  const customerId = get(store, 'common.profiles.0.customer_id', null);
  return customerId;
};

export const getWorkbenchMode = () => {
  const workbenchMode = useInitialInfoStore.getState().workbenchMode;
  return workbenchMode;
};

const addCustomerIdHeader = (reqConfig) => {
  const cid = getCustomerID();
  if (cid) {
    /* eslint-disable no-param-reassign */
    reqConfig.headers['X-cid'] = btoa(cid);
  }
  return reqConfig;
};

const addTraceIdHeader = (reqConfig) => {
  const traceId = uuidv4().replace(/-/g, '');
  if (traceId) {
    /* eslint-disable no-param-reassign */
    reqConfig.headers['x-cvv-trace-id'] = traceId;
  }
  return reqConfig;
};

const addWorkbenchModHeader = (reqConfig) => {
  const mode = getWorkbenchMode();
  if (mode) {
    /* eslint-disable no-param-reassign */
    reqConfig.headers['workbench-mode'] = mode;
  }
  return reqConfig;
};

const forceReload = (response) => {
  if (response.status === 205) {
    // customer id mistmatch, reload page
    window.location.reload();
    return null;
  }
  return response;
};

export function addCustomerIdInterceptors(axi) {
  axi.interceptors.request.use(addCustomerIdHeader, (error) => Promise.reject(error));

  axi.interceptors.request.use(addTraceIdHeader, (error) => Promise.reject(error));
  axi.interceptors.request.use(addWorkbenchModHeader, (error) => Promise.reject(error));

  // Will enable later
  // axi.interceptors.request.use(addProductContextHeader, (error) => Promise.reject(error));

  axi.interceptors.response.use(forceReload, (error) => Promise.reject(error));
}

addCustomerIdInterceptors(instance);

export default instance;
